import React from 'react';
import { SubTitle } from "./TypographyComponent";
import { Grid, Stack,useMediaQuery,IconButton } from '@mui/material';
import { useLocation,useNavigate } from 'react-router-dom';
import { BackButton } from './ButtonComponent';
import Link from './LinkComponent';
import EmailButton from '../About/EmailButtonComponent'
import ThemeToggler from '../../styles/themeToggler';


/*
Navigation Component --- NameComponent, ThemeToggler, Links
-----------------------------------------------------------
*/


const Navigation = () => {

    //Navigation Hooks
    let location = useLocation();
    let navigate = useNavigate();
    //Routes
    let homeNav = (location.pathname === '/');
    let blogNav = (location.pathname.startsWith('/blog'));
    //Mobile MediaQuery
    const Mobile = useMediaQuery(theme => theme.breakpoints.only('xs'))




    return (
        <>

            
            {
                /* Nav for Home Page */
                homeNav ?

             
                <Grid container justifyContent={"space-between" } sx={{position:"fixed", px:1.5, zIndex:1600}}>

                    {Mobile ? null :
                        <Grid item sx={{py:1.5}}>
                            <SubTitle>Nasir Abdirahman</SubTitle> 
                        </Grid>
                    }
                    
                    {Mobile ?
                        <Grid container justifyContent={"space-between" }sx={{position:"fixed", px: 1.5,zIndex:1600}}>
                            <Grid item sx={{py:1.5}}>
                                <ThemeToggler/>
                            </Grid>
            
                            <Stack direction="row" spacing={7} sx={{ py:1.5, px:1 }}justifyContent="flex-end" >
                                <Link to="/projects" aria-label={"View Nasir's Projects"}>
                                    <SubTitle>Projects</SubTitle>
                                </Link>
                                <Link to="/blog" aria-label={"Read Nasir's Blog"}>
                                    <SubTitle>Blog</SubTitle>
                                </Link>
                            </Stack>
                            
                        </Grid>

                        :

                        <Stack direction="row" spacing={7} sx={{ pt:1.5 }}justifyContent="flex-end" >
                            <Link to="/projects" aria-label={"View Nasir's Projects"}>
                                <SubTitle>Projects</SubTitle>
                            </Link>
                            <Link to="/blog" aria-label={"Read Nasir's Blog"}>
                                <SubTitle>Blog</SubTitle>
                            </Link>
                            <EmailButton />
                            <ThemeToggler/>
                        </Stack>
                    }
                </Grid>
              

                :
                

                /* Nav for Blog Page */
                blogNav ?
                    
                    Mobile ?
                        <Grid container justifyContent={"space-between" }sx={{position:"fixed", px: 1.5,zIndex:1600}}>
                            <Grid item sx={{py:1.5}}>
                                <ThemeToggler/>
                            </Grid>
            
                            <Stack direction="row" spacing={7} sx={{ py:1.5, px:1 }}justifyContent="flex-end" >
                                <Link to="/" aria-label={"Go to Home"}>
                                    <SubTitle>Home</SubTitle>
                                </Link>

                                <Link to="/projects" aria-label={"View Nasir's Projects"}>
                                    <SubTitle>Projects</SubTitle>
                                </Link>
                            </Stack>
                            
                        </Grid>
                        :
                        <Grid container justifyContent={"space-between" } sx={{position:"fixed", px: 1.5, zIndex:1600}}>
                    
                            <IconButton disableRipple aria-label="Back" onClick={()=> navigate(-1)} >
                                <BackButton/>
                            </IconButton>

                            <Stack direction="row" spacing={7} sx={{ pt:1.5}} >

                                <Link to="/" aria-label={"Go to Home"}>
                                    <SubTitle>Home</SubTitle>
                                </Link>

                                <Link to="/projects" aria-label={"View Nasir's Projects"}>
                                    <SubTitle>Projects</SubTitle>
                                </Link>

                                <EmailButton />
                                <ThemeToggler/>

                            </Stack>

                        </Grid>

                :


                /* Nav for Projects Page */

                Mobile ? 
                    <Grid container justifyContent={"space-between" }sx={{position:"fixed", px: 1.5,zIndex:1600}}>
                        <Grid item sx={{py:1.5}}>
                            <ThemeToggler/>
                        </Grid>
        
                        <Stack direction="row" spacing={7} sx={{ py:1.5, px:1 }}justifyContent="flex-end" >
                            <Link to="/" aria-label={"Go to Home"}>
                                <SubTitle>Home</SubTitle>
                            </Link>

                            <Link to="/blog" aria-label={"Read Nasir's Blog"}>
                                <SubTitle>Blog</SubTitle>
                            </Link>
                        </Stack>
                        
                    </Grid>
                :
                <Grid container justifyContent={"space-between" } sx={{position:"fixed", px: 1.5, zIndex:1600}}>

                    <IconButton disableRipple aria-label="Back" onClick={()=> navigate(-1)} >
                        <BackButton/>
                    </IconButton>

                    <Stack direction="row" spacing={7} sx={{ pt:1.5}} >

                        <Link to="/" aria-label={"Go to Home"}>
                            <SubTitle>Home</SubTitle>
                        </Link>

                        <Link to="/blog" aria-label={"Read Nasir's Blog"}>
                            <SubTitle>Blog</SubTitle>
                        </Link>

                        <EmailButton />
                        <ThemeToggler/>

                    </Stack>

                </Grid>

            }
          
  
        </>
    ) 


}



export default Navigation;